
// 新接口
import axios from 'axios'
import Encode from './encode'
import storage from 'storejs'
import store from './../../store'

export const api = function (url, body, platform, method) {
  const CancelToken = axios.CancelToken
  const data = {
    'brand': '',
    'guid': store.state.user.guid ? store.state.user.guid : window.uuid, // 必传
    'model': '',
    'platform': platform || 'WeChat',
    'sysVersion': '',
    'time': parseInt(+new Date() / 1000),
    'uid': store.state.user.uid ? store.state.user.uid : 0, // 必传
    'version': '1.0',
    'session': store.state.user.session ? store.state.user.session : '',
    'body': body
  }
  console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', data)
  console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', body)
  let sendData = Encode.encodeFunc(data)
  return new Promise((resolve, reject) => {
    axios({
      method: method || 'post',
      url: window.API_ROOT + url,
      data: sendData,
      cancelToken: new CancelToken(function executor (cancel) {
        // 2.将cancel token存入列表
        if (url === 'content/getArticleListByTopic') {
          window.axiosPromiseArr.push({ cancel })
          console.log(window.axiosPromiseArr)
        }
      })
    })
      .then((res) => {
        // console.log(res);
        let getData = res.data
        let decodeGetData = JSON.parse(Encode.decodeFuc(getData.data)) // 解密data   获取的是字符串
        // let toAes = Encode.encodeFunc(decodeGetData) // 对解密的数据加密
        console.log(`%c 响应：${url}`, 'color: green;font-size:16px;', decodeGetData)
        if (decodeGetData.code === 200) {
          resolve(decodeGetData.body)
        } else {
          const timeError = {
            msg: decodeGetData.msg,
            data: decodeGetData,
            code: decodeGetData.code
          }
          reject(timeError)
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('请求取消')
        } else {
          console.log(err)
          let error = {
            msg: '服务器开小差啦'
          }
          console.debug(err)
          reject(error)
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/server/api/api.js